import React from 'react';
// import { TextField } from '@material-ui/core';
// import InputAdornment from '@material-ui/core/InputAdornment';
// import SearchIcon from '@material-ui/icons/Search';
// AG-GRID
// import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
// import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
// import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS

export const SearchProductPage = () => {



//         const [inputValue, setInputValue] = useState('');
//         const [loadingInput, setLoadingInput] = useState(false);
//         const [columnDefs, setColumnDefs] = useState([]);
//         const [products, setProducts] = useState([]);
      
//         const handleInputChange = (event) => {
//             setInputValue(event.target.value);
//         // setLoadingInput
//         //   setTimeout(() => {
//         //     console.log("¡Se ejecutó después de 3000 milisegundos!");

//         //   },[3000])
//         };
//         const getData = async(inputValue) => {
//             setLoadingInput(true)
//             const response = await fetch(`${process.env.REACT_APP_API_URL}/lasir/search_product?value=${inputValue}`, {
//                 method: 'GET',
//                 headers: {
//                   'Content-Type': 'application/json',
//                 },
                
//             });
    
//             const data = await response.json();
//             console.log("data: ", data);
//             setProducts(data)
//             if (data && data?.length > 0) {
//                 console.log("data", data[0]);
//                 const keys = Object.keys(data[0])
//                 console.log(keys);
//                 let newKeys = keys.map((el) => {
//                     if (!isNaN(el)) { // Comprueba si el valor es un número
//                         const date = new Date(parseInt(el)); // Convierte el timestamp a una fecha
//                         const day = date.getDate().toString().padStart(2, '0'); // Obtiene el día en formato "dd"
//                         const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Obtiene el mes en formato "mm" (0-indexed)
//                         const year = date.getFullYear(); // Obtiene el año en formato "yyyy"
//                         const newDate = `${day}/${month}/${year}`; 
//                         return {
//                             field: el,
//                             headerName: newDate,
//                             width: 150,
//                             valueFormatter: (params) => {
//                                 // Personaliza la lógica del valueFormatter aquí
//                                 return params?.value ? `$${params?.value}` : 0;
//                               },
//                         }
//                     } 
//                     if (el ==="max_value_column") {
//                         console.log();
                         
//                         return {
//                             field: el,
//                             headerName:'Fecha de factura mayor',
//                             valueFormatter: (params) => {
//                                 if (params?.value) {
//                                     const date = new Date(parseInt(params?.value)); // Convierte el timestamp a una fecha
//                                     const day = date.getDate().toString().padStart(2, '0'); // Obtiene el día en formato "dd"
//                                     const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Obtiene el mes en formato "mm" (0-indexed)
//                                     const year = date.getFullYear(); // Obtiene el año en formato "yyyy"
//                                     const newDate = `${day}/${month}/${year}`; 
//                                     return newDate
//                                 }
                                
//                                 return '';
//                               },
//                         }
                        
//                     }
                   
//                     return {
//                         field: el,
//                         width: 150,
//                         // valueFormatter: (params) => {
//                         //     // Personaliza la lógica del valueFormatter aquí
//                         //     return params?.value ? `$${params?.value}` : 0;
//                         //   },
//                     };
                    
                      
//                 })
//                 newKeys = newKeys.sort((a, b) => {
//                     // Si el campo "barcode" está presente en a, lo colocamos primero
//                     if (a.field === "bar_code") return -1;
//                     // Si el campo "barcode" está presente en b, lo colocamos segundo
//                     if (b.field === "bar_code") return 1;
//                     // En cualquier otro caso, mantenemos el orden original
//                     return 0;
//                 });
//                 console.log("newKeys: ", newKeys);
            
//                 setColumnDefs(newKeys)
//             }
//             setLoadingInput(false)

//         };
//         useEffect(async() => {
//             if (inputValue.length > 2) {
//                 console.log(inputValue);
//                 getData(inputValue)
//             }
//         }, [inputValue.length])


//         // AG GRID
//     const gridApiRef = useRef(null);
//     useEffect(() => {
//         const allData = [];
//         if (gridApiRef.current) {
//           gridApiRef.current.api.forEachNode((node) => {
//             allData.push(node.data);
//           });
//         }
//         return allData;
//       },[]);

//       const defaultColDef = useMemo(() => ({
//         sortable: true, 
//         minWidth: 100,
//         menuTabs:['filterMenuTab'],
//         suppressMenu: true,
//         // suppressMenuHide: true,
//         unSortIcon: false,
//         floatingFilter: true,
//         filter: true,
//         resizable: true,
//       }), []);
      
//         return (
//             <>
//               <div className='row'>
//                 <div className="row d-flex justify-content-center">
//                     <div className="col-4">
//                         <TextField
//                             size="small"
//                             variant="outlined"
//                             fullWidth
//                             value={inputValue}
//                             placeholder='Buscar producto'
//                             onChange={handleInputChange}
//                             disabled={loadingInput}
//                             InputProps={{
//                                 startAdornment: (
//                                 <InputAdornment position="start">
//                                     <SearchIcon />
//                                 </InputAdornment>
//                                 ),
//                             }}
//                         />
//                     </div>
//                     <div className="col-12">
//                     <hr />
//                     {
                        
//                         (columnDefs.length > 0 && products.length > 0)&& (
//                             <div id="myGrid" style={{ height: '500px', width: '100%'}} className="ag-theme-alpine">
// <AgGridReact
//           onGridReady={(params) => (gridApiRef.current = params)}
//           defaultColDef={defaultColDef}
//           pagination={true}
//           paginationPageSize={200}
//           stopEditingWhenCellsLoseFocus={true}
//           rowData={products}
//           columnDefs={columnDefs}
//         />

//                             </div>
//                         )
//                     }
//                     </div>
//                 </div>
                    
//               </div>
//             </>
//         );
      return (<></>)
      
};